import TabOptions from '../options';
import SwAlert from '@/mixins/alert.mixin';
import { copy } from '@/utils/objUtils';
import OptionTypes from '@/utils/constants/vocationalEvaluationOptionTypes';

const isInterestProfileOption = (option) =>
  option?.type?.id === OptionTypes.VocationalInterestsOccupationalPreferences;

const selectedInterestOptionIds = (model) =>
  (model?.options ?? [])
    .filter((option) => isInterestProfileOption(option) && option.checked)
    .map((option) => option.id)
    .sort((a, b) => a - b);

const hasSameValues = (from, to) =>
  from.length === to.length &&
  from.every((value, index) => value === to[index]);

export class Model {
  records = [];
  options = [];
}
export class Tab {
  id = 'OnePartB';
  title = 'I.B';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    return {
      tab: this.id,
      ...model,
      onePartBOptions: model.options.filter((x) => x.checked),
    };
  };
  confirm = async (model) => {
    const initialModel = this.options.initialModel;
    const unchecks = model.options.filter((x) => !x.checked);
    const interestOptions = model.options.filter(isInterestProfileOption);
    const interestOptionIds = interestOptions.map((x) => x.id);
    const hasInterestProfileDocumentation = interestOptions.some(
      (x) => x.hasInterestProfileDocumentation
    );
    const hasInterestProfileChanges = !hasSameValues(
      selectedInterestOptionIds(model),
      selectedInterestOptionIds(initialModel)
    );

    model.dropInstrumentOptions = unchecks.map((x) => x.id);
    let confirmedInterestProfileDocumentationRemoval = false;

    if (hasInterestProfileDocumentation && hasInterestProfileChanges) {
      const { value, dismiss } = await SwAlert.methods.ShowCancelModalClosable(
        'Confirmación',
        '<div>La información registrada en el Instrumento Perfil de Intereses se eliminará de forma permanente.</div><div>¿Desea continuar?</div>',
        'Sí',
        'No',
        false,
        false
      );
      const cancelled = ['close', 'backdrop'].includes(dismiss);
      const confirmed = !cancelled && value;

      if (!confirmed) {
        Object.assign(this.model, copy(initialModel));
        return false;
      }

      model.dropInstrumentOptions = [
        ...new Set([...model.dropInstrumentOptions, ...interestOptionIds]),
      ];
      confirmedInterestProfileDocumentationRemoval = true;
    }

    const uncompleteds = unchecks
      .filter(
        (x) =>
          !confirmedInterestProfileDocumentationRemoval ||
          !isInterestProfileOption(x)
      )
      .filter((x) => x.hasCompletedInstrument)
      .map((x) => x.id);

    if (!uncompleteds.length) return true;
    const { value, dismiss } = await SwAlert.methods.ShowCancelModalClosable(
      'Confirmación',
      '<div>Actualmente el instrumento correspondiente a esta evaluación se encuentra en estatus <b>Completado</b>, al remover se eliminará el instrumento,</div><div>¿Desea continuar?</div>',
      'Sí',
      'No',
      false,
      false
    );
    const cancelled = ['close', 'backdrop'].includes(dismiss);
    const confirmed = !cancelled && value;
    return confirmed;
  };
}
export default new Tab();
